import React, { useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import './NotesEditorModal.css';

function NotesEditorModal(props) {
    const { show, handleClose, initialNotes, onSave, ownPage } = props;
    const [currentNotes, setCurrentNotes] = useState(initialNotes);

    useEffect(() => {
        setCurrentNotes(initialNotes);
    }, [initialNotes]);

    useEffect(() => {
        if (!show) {
            setCurrentNotes(initialNotes);
        }
    }, [show, initialNotes]);

    const handleNotesChange = (event) => {
        setCurrentNotes(event.target.value);
    };

    const handleSave = () => {
        onSave(currentNotes); 
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleClose} centered dialogClassName="notes-modal-dialog">
            <Modal.Header>
                <Modal.Title className="modal-title">
                    Enter Notes
                </Modal.Title>
                <button type="button" className="close-btn" onClick={handleClose} aria-label="Close">
                    <i className="fas fa-times"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Form.Group controlId="notesTextArea">
                    <Form.Control
                        as="textarea"
                        rows={8}
                        placeholder="Enter notes here"
                        value={currentNotes}
                        onChange={handleNotesChange}
                        readOnly={!ownPage}
                        className="notes-textarea"
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <button
                    className="btn btn-primary"
                    onClick={handleSave}
                    disabled={!ownPage}
                    type="button"
                >
                    Save
                </button>
                <button
                    className="btn btn-link"
                    onClick={handleClose}
                    type="button"
                >
                    Cancel
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default NotesEditorModal;